var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vu-meter"},[_c('canvas',{directives:[{name:"draw-meter",rawName:"v-draw-meter",value:({
      amp: _vm.dBVal,
      peak: _vm.dBPeakVal,
      clipSize: _vm.clipSize,
      showPeaks: _vm.showPeaks,
      newVolumePercentage: _vm.newVolumePercentage,
      volumeDefault: _vm.volumeDefault,
      previewId: _vm.previewId
    }),expression:"{\n      amp: dBVal,\n      peak: dBPeakVal,\n      clipSize: clipSize,\n      showPeaks: showPeaks,\n      newVolumePercentage: newVolumePercentage,\n      volumeDefault: volumeDefault,\n      previewId: previewId\n    }"}],attrs:{"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }